import { Injectable, isDevMode } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PlatformLocation } from '@angular/common';

// jquery
declare const $: any;

@Injectable({
  providedIn: 'root'
})
export class VersionCheckService {

  private avisou = false;

  constructor(private http: HttpClient, private platformLocation: PlatformLocation) { }

  public iniciar() {

    if (isDevMode()) {
      return;
    }

    this.avisou = false;

    setInterval(() => {

      if (this.avisou) {
        return;
      }

      this.http.get(location.origin + this.platformLocation.getBaseHrefFromDOM() + 'assets/config/version.json?t=' + new Date().getTime())
        .first().subscribe((resp: any) => {
          if (resp.versao !== environment.appVersion) {
            this.avisou = true;

            $.notify({
              icon: 'notifications',
              message: 'Nova atualização do sistema!!!'
            }, {
              type: 'info',
              timer: 0,
              placement: {
                from: 'top',
                align: 'right'
              },
              template: `<div data-notify="container" class="col-11 col-md-8 col-lg-6 col-xl-4  mt-1 alert alert-{0} alert-with-icon"
             role="alert">
            <i class="material-icons text-primary" data-notify="icon">update</i>
            <div class="d-flex align-items-center justify-content-between">
              <div class="">
              <span data-notify="message">{2}</span>
              </div>

            <div class="text-center"><button mat-raised-button type="button" aria-hidden="true"
             class="btn btn-primary d-flex align-items-center" onclick="location.reload()">Atualizar
            </button></div>
            </div>


            </div>`
            });
          }
        }, (err) => {
          console.error(err, 'Could not get version');
        });


    }, 300000);
  }

}
